module.exports = __webpack_public_path__ + "static/img/3.2131074.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/eng/3.png
// module id = q7DM
// module chunks = 0